// Swiper 6.0+
import Swiper, { Navigation, Pagination } from 'swiper';


export class Swp {
    constructor() {
        this.hasSwipers = false;//main.jsでswiperが使われているかどうか確認する

        //works
        this.hasWorksSwp = false;//html要素としてworks-swiperが存在するかどうか
        this.worksBreakPoint = 700;
        this.worksSwipers;
        this.worksSwpFlg = false;//現在の解像度でworks-swiperが有効かどうか

        //curation
        this.hasCurationSwp = false;//html要素としてcuration-swiperが存在するかどうか
        this.curationBreakPoint = 700;
        this.curationSwipers;
        this.curationSwpFlg = false;//現在の解像度でcuration-swiperが有効かどうか
    }

    onResize(){
        //console.log('swiper onresize');

        //single-works
        if (document.querySelectorAll('.works-swiper')[0]) {
            // PC/SPとも表示
            // if (this.worksBreakPoint < window.innerWidth && this.worksSwpFlg) {
            //     // PC　表示
            //     this.worksCreateSwiper();
            //     this.worksSwpFlg = true;
            // } else if (this.worksBreakPoint >= window.innerWidth && !(this.worksSwpFlg)) {
            //     // SP　非表示
            //     this.worksSwipers.destroy(false, true);
            //     this.worksSwpFlg = false;
            // }
        }

        //index-curation
        if (document.querySelectorAll('.curation-swiper')[0]) {
            if (this.curationBreakPoint < window.innerWidth && this.curationSwpFlg) {
                // PC Swiperを無効化
                [].forEach.call(this.curationSwipers, function (elem) {
                    elem.destroy(false, true);
                });
                this.curationSwpFlg = false;
                //console.log('PC Swiperを無効化 index-curation');
            } else if (this.curationBreakPoint >= window.innerWidth && !(this.curationSwpFlg)) {
                // SP Swiperを有効化
                this.createSwiper2();
                this.curationSwpFlg = true;
                //console.log('SP Swiperを有効化 index-curation');
            }
        }
    }
    
    createSwiper1(){
        //single-works 原稿内
        this.worksSwipers = new Swiper('.js-works-swiper', {
            //speed: 900,
            //slideToClickedSlide: true,
            loop: true,
            modules: [Pagination,Navigation],
            spaceBetween: 1,
            slidesPerView: 'auto',
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        //console.log(this.worksSwipers.length);
    }

    createSwiper2(){
        // indexページのcuration
        this.curationSwipers = new Swiper('.js-curation-swiper', {
            //speed: 900,
            //slideToClickedSlide: true,
            modules: [Pagination],
            spaceBetween: 30,
            slidesPerView: 'auto',
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
        });
        //console.log('curationSwiper: ' + this.curationSwipers);
    }

    init() {
        //works-swiper(single-work原稿内)
        if (document.querySelectorAll('.js-works-swiper')[0]) {
            this.hasWorksSwp = true;
            this.hasSwipers = true;
            this.createSwiper1();
        }

        // index-curation
        if (document.querySelectorAll('.js-curation-swiper')[0]) {
            //console.log('detect curation-swiper');
            this.hasCurationSwp = true;
            this.hasSwipers = true;
            if (this.curationBreakPoint < window.innerWidth) {
                this.curationSwpFlg = false;
            } else {
                this.createSwiper2();
                this.curationSwpFlg = true;
            }
        }
    }

}